import React from "react";
import { marqueeItems } from "../data";

function MarqueeSection() {
  return (
    <section className="marquee-section py-[10px]" aria-label="Quick links">
      <div className="marquee" role="list">
        <ul className="marquee__track">
          {marqueeItems.concat(marqueeItems).map((item, idx) => (
            <li className="marquee__item" key={idx}>
              <span className="body-lg text-white">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default MarqueeSection;
